"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _IconFlippingChevron = _interopRequireDefault(require("../IconFlippingChevron"));

var _IconExternalLink = _interopRequireDefault(require("./IconExternalLink"));

var _IconGitLab = _interopRequireDefault(require("./IconGitLab"));

var _index = require("./index.styles");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Copyright © VNG Realisatie 2021
// Licensed under the EUPL
//


var defaultDomains = [{
  domain: 'CommonGround.nl',
  description: 'Community voor Samen Organiseren',
  to: 'https://commonground.nl'
}, {
  domain: 'Componenten­catalogus',
  description: 'Overzicht van herbruikbare software binnen de Nederlandse gemeenten',
  to: 'https://componentencatalogus.commonground.nl'
}, {
  domain: 'NLX',
  description: 'Wissel snel, veilig en AVG-proof gegevens uit tussen overheidsorganisaties',
  to: 'https://nlx.io'
}, {
  domain: 'Haven',
  description: 'Gestandaardiseerde infrastructuur voor het aanbieden en beheren van applicaties',
  to: 'https://haven.commonground.nl'
}, {
  domain: 'Developer Overheid',
  description: 'Eén centrale plek voor de developer die voor of met de overheid ontwikkelt',
  to: 'https://developer.overheid.nl'
}];

var DomainNavigation = function DomainNavigation(_ref) {
  var activeDomain = _ref.activeDomain,
      ariaLabel = _ref.ariaLabel,
      domains = _ref.domains,
      dropdownLabel = _ref.dropdownLabel,
      gitLabLink = _ref.gitLabLink;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var listRef = (0, _react.useRef)();
  var dropdownRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var handleClickOutside = function handleClickOutside(event) {
      var _listRef$current, _dropdownRef$current;

      if (!((_listRef$current = listRef.current) !== null && _listRef$current !== void 0 && _listRef$current.contains(event.target) || (_dropdownRef$current = dropdownRef.current) !== null && _dropdownRef$current !== void 0 && _dropdownRef$current.contains(event.target))) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [listRef]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_index.Navigation, {
    "aria-label": ariaLabel
  }, /*#__PURE__*/_react["default"].createElement(_index.IntroText, null, "Onderdeel van", " ", /*#__PURE__*/_react["default"].createElement("br", null), "Common Ground"), /*#__PURE__*/_react["default"].createElement(_index.DropdownButton, {
    "aria-expanded": isOpen,
    onClick: function onClick() {
      return setOpen(!isOpen);
    },
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && setOpen(!isOpen);
    },
    ref: dropdownRef,
    role: "button",
    tabIndex: "0"
  }, dropdownLabel, /*#__PURE__*/_react["default"].createElement(_IconFlippingChevron["default"], {
    flipHorizontal: isOpen
  })), /*#__PURE__*/_react["default"].createElement(_index.DomainListDesktop, null, domains.map(function (option) {
    var isSelected = option.domain === activeDomain;
    return /*#__PURE__*/_react["default"].createElement(_index.ListItemDesktop, {
      href: option.to,
      isSelected: isSelected,
      disabled: isSelected,
      key: option.domain,
      rel: "noreferrer",
      tabIndex: isSelected ? -1 : 0,
      target: "_blank"
    }, /*#__PURE__*/_react["default"].createElement("span", null, option.domain), /*#__PURE__*/_react["default"].createElement("span", null, option.domain));
  })), gitLabLink && /*#__PURE__*/_react["default"].createElement(_index.GitLabLink, {
    href: gitLabLink,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(_index.GitLabIcon, {
    as: _IconGitLab["default"]
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, "GitLab"), /*#__PURE__*/_react["default"].createElement("span", null, "GitLab"))), isOpen && /*#__PURE__*/_react["default"].createElement(_index.DropdownList, {
    ref: listRef
  }, domains.map(function (option) {
    var isSelected = option.domain === activeDomain;
    return /*#__PURE__*/_react["default"].createElement(_index.ListItem, {
      isSelected: isSelected,
      key: option.domain
    }, /*#__PURE__*/_react["default"].createElement("a", {
      as: !isSelected ? 'a' : 'span',
      href: option.to,
      onClick: function onClick() {
        return setOpen(function (isOpen) {
          return false;
        });
      },
      rel: "noreferrer",
      tabIndex: isSelected ? -1 : 0,
      disabled: isSelected,
      target: "_blank"
    }, /*#__PURE__*/_react["default"].createElement(_index.Label, {
      isActive: isSelected
    }, option.domain, option.description && /*#__PURE__*/_react["default"].createElement("span", null, option.description)), !isSelected && /*#__PURE__*/_react["default"].createElement(_index.ExternalSiteIcon, {
      as: _IconExternalLink["default"],
      inline: true
    })));
  }))));
};

DomainNavigation.defaultProps = {
  ariaLabel: 'Domain navigatie',
  dropdownLabel: 'CG Producten',
  domains: defaultDomains
};
DomainNavigation.propTypes = {
  activeDomain: _propTypes.string.isRequired,
  ariaLabel: _propTypes.string,
  domains: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    domain: _propTypes.string.isRequired,
    description: _propTypes.string.isRequired,
    to: _propTypes.string.isRequired
  })),
  dropdownLabel: _propTypes.string,
  gitLabLink: _propTypes.string
};
var _default = DomainNavigation;
exports["default"] = _default;